import axios, { InternalAxiosRequestConfig } from 'axios'
import Cookies from 'js-cookie'
import { USERNAME_COOKIE } from '../core/constants'
import { TAuthUser } from '../core/types/Auth'
import { TCollaborator } from '../core/types/Collaborators'
import env from '../core/config/env'

const processRequestToken = (config: InternalAxiosRequestConfig<any>) => {
  const userCookie = Cookies.get(USERNAME_COOKIE)
  const user: TAuthUser | null = userCookie ? JSON.parse(userCookie) : null
  const session = sessionStorage.getItem('session')
  const userSession = session ? (JSON.parse(session) as TCollaborator) : null
  const token = userSession?.token ? userSession.token : user?.token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}

const api = axios.create({
  baseURL: env.HOST,
  timeout: 500000,
})

api.interceptors.request.use(processRequestToken)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      Cookies.remove(USERNAME_COOKIE)
      sessionStorage.removeItem('session')
      window.location.href = '/'
    }
    return Promise.reject(error)
  }
)

export default api

export const apiReport = axios.create({
  baseURL: env.REPORT_HOST,
  timeout: 500000,
})

apiReport.interceptors.request.use(processRequestToken)

export const isErrorApi = (error: any) => {
  return axios.isAxiosError(error)
}

/*export const setAuthorization = (token: string) => {
  if (token !== null && token !== '') {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`
    apiReport.defaults.headers.common['Authorization'] = `Bearer ${token}`
  } else {
    api.defaults.headers.common['Authorization'] = ''
    apiReport.defaults.headers.common['Authorization'] = ''
  }
}*/

export const getResponseError = (error: unknown) => {
  var message = 'Erro não identificado'

  try {
    const err: any = error
    if (err && err !== null) {
      if (err.response) {
        if (err.response.data) {
          if (err.response.data.errors) {
            try {
              const errors: any[] = err.response.data.errors
              const list = errors.map((item: any) => item.message).join('\n')
              return list
            } catch (e) {
              console.error(e)
              try {
                const errors: any = err.response.data.title
                return errors.toString()
              } catch (er) {}
            }
          }
          if (err.response.data.detail) {
            return err.response.data.detail
          }
        }
      }
    }
  } catch (e) {
    console.error(e)
  }

  if (typeof error === 'string') {
    message = error.toUpperCase()
  } else if (error instanceof Error) {
    const err = error as Error
    message = err.message
  }

  return message
}
